import * as z from 'zod';

export const BoxLocalStorageData = z.object({
  likedAnswerIds: z.array(z.number()).optional(),
  viewNewQuestionsAt: z.string().optional(),
});
export type BoxLocalStorageData = z.infer<typeof BoxLocalStorageData>;
